import { keyframes } from '@emotion/react';
import { Box, styled } from '@mui/material';

const press = keyframes`
    0% { transform: scale(1); }
    50% { transform: scale(0.99); }
    100% { transform: scale(1); }
  `;

type NotificationBlockContainerType = {
  isHideBoxShadow?: boolean;
  isClickable?: boolean;
  isClicked?: boolean;
  backgroundColor?: string;
  borderColor?: string;
  color?: string;
  hoverBackgroundColor?: string;
  hoverBorderColor?: string;
  activeBorderColor?: string;
};

export const NotificationBlockContainer = styled(Box, {
  shouldForwardProp: (prop: string) =>
    ![
      'isHideBoxShadow',
      'isClickable',
      'isClicked',
      'backgroundColor',
      'borderColor',
      'color',
      'hoverBackgroundColor',
      'hoverBorderColor',
      'activeBorderColor',
    ].includes(prop),
})<NotificationBlockContainerType>(
  ({
    theme,
    isHideBoxShadow,
    isClicked,
    isClickable,
    backgroundColor,
    borderColor,
    color,
    hoverBackgroundColor,
    hoverBorderColor,
    activeBorderColor,
  }) => ({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: backgroundColor || theme.palette.case.blue.b100,
    border: `1px solid ${borderColor || theme.palette.case.blue.b200}`,
    padding: '12px',
    borderRadius: '8px',
    minHeight: '24px',
    boxShadow: isHideBoxShadow ? '' : theme.palette.case.shadow.big,
    transition: 'background-color 0.3s ease, border 0.1s ease',
    color: color || theme.palette.case.blue.b700,

    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
    },

    ...(isClicked && {
      animation: `${press} 0.3s ease`,
    }),
    ...(isClickable && {
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: hoverBackgroundColor || theme.palette.case.blue.b200,
        border: `1px solid ${hoverBorderColor || theme.palette.case.blue.b300}`,
      },
      '&:active': {
        border: `1px solid ${activeBorderColor || theme.palette.case.blue.b500}`,
      },
    }),
  }),
);
